import React, { useState } from "react";
import QuantityControl from "./QuantityControl";
import ToggleControl from "./ToggleControl";
import OptionList from "./OptionList";
import BreakdownModal from "./BreakdownModal";
import "./FoodItem.css";
import { getAddonQuantity, shouldShowOptions } from "./addonLogic";

export default function Addon({
  addon,
  foodItemQuantity,
  selectedAddon,
  onAddonQuantityChange,
  onAddonToggle,
  onRadioOptionToggle,
  onCheckboxOptionToggle,
  onOptionQuantityChange,
  onSubOptionChange,
}) {
  const isChecked = selectedAddon?.enabled;
  const isLinked = addon.isCountable && addon.isCountableLinked;

  const quantity = getAddonQuantity({
    addon,
    selectedAddon,
    foodItemQuantity,
    isChecked,
    isLinked,
  });

  // State for controlling BreakdownModal visibility
  const [showBreakdownModal, setShowBreakdownModal] = useState(false);

  // Handlers for opening and closing the modal
  const handleQuantityClick = () => {
    if (quantity > 0) {
      setShowBreakdownModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowBreakdownModal(false);
  };

  const showOptions = shouldShowOptions({ addon, selectedAddon, quantity });

  return (
    <div className='addon'>
      <div className='d-flex align-items-center'>
        <h3 className='form-check-label ordercartTitle mb-0'>
          {addon.addOnName}
          {quantity > 0 && (
            // Made quantity clickable to open modal
            <span
              onClick={handleQuantityClick}
              style={{ cursor: quantity > 0 ? "pointer" : "default" }}
              className='quantity-display'
            >
              (x{quantity})
            </span>
          )}
          {addon.isMandatory && <span className='text-danger'> *</span>}
          
          {addon.isCountableLinked && (
            <i
              className='fas fa-link ms-2 text-primary'
              title='This add-on is linked to the main item and its quantity will increase if you increase the item quantity down below'
            ></i>
          )}
        </h3>
        <div className='d-flex align-items-center ms-auto gap-2'>
          {addon.isCountable && (
            <div className='align-self-center'>
              <QuantityControl
                value={quantity}
                onIncrease={() => onAddonQuantityChange(addon, +1)}
                onDecrease={() => onAddonQuantityChange(addon, -1)}
                hideTitle={true}
                type='addon'
              />
            </div>
          )}

          {/* <span className='fw-semibold'>${addon.basePrice}</span> */}
          <span className='fw-semibold'>
            £{quantity <= 0 ? addon.basePrice : (addon.basePrice * quantity).toFixed(2)}
          </span>
          {!addon.isCountable && (
            <ToggleControl
              checked={selectedAddon?.enabled}
              onToggle={() => onAddonToggle(addon)}
            />
          )}
        </div>
      </div>

      {addon.options?.length > 0 && showOptions && (
        <OptionList
          options={addon.options}
          minSelection={addon.minSelection}
          maxSelection={addon.maxSelection}
          addonId={addon.id}
          foodItemQuantity={foodItemQuantity}
          optionButtonId={addon.optionButtonId}
          selectedOptions={selectedAddon?.options || {}}
          onRadioOptionToggle={onRadioOptionToggle}
          onCheckboxOptionToggle={onCheckboxOptionToggle}
          onOptionQuantityChange={onOptionQuantityChange}
          onSubOptionChange={onSubOptionChange}
        />
      )}

      {/* BreakdownModal props to pass only specific addon and selectedAddon */}
      <BreakdownModal
        show={showBreakdownModal}
        onHide={handleCloseModal}
        addon={addon}
        selectedAddon={selectedAddon}
        foodItemQuantity={foodItemQuantity}
      />
    </div>
  );
}
